import { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";

interface BrandCardProps {
  name: string;
  tagline: string;
  description: string;
  services: string[];
  colorClass: string;
  website: string;
  number: string;
  accentVar: string;
}

const BrandCard = ({
  name,
  tagline,
  description,
  services,
  website,
  number,
  accentVar,
}: BrandCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`glass-card group transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      }`}
    >
      <div
        className="h-[2px]"
        style={{ background: `hsl(var(${accentVar}))` }}
      />

      <div className="p-6 sm:p-8 md:p-10 relative z-10">
        <div className="flex items-start justify-between mb-4 sm:mb-6">
          <div>
            <span
              className="text-xs font-medium tracking-[0.2em] uppercase"
              style={{ color: `hsl(var(${accentVar}))` }}
            >
              {tagline}
            </span>
            <h3 className="font-serif text-2xl sm:text-3xl md:text-4xl text-foreground mt-1">
              {name}
            </h3>
          </div>
          <span className="font-serif text-4xl sm:text-5xl leading-none" style={{ color: `hsl(var(${accentVar}) / 0.2)` }}>
            {number}
          </span>
        </div>

        <p className="text-muted-foreground leading-relaxed mb-6 sm:mb-8 text-sm">
          {description}
        </p>

        <div className="flex flex-wrap gap-2 mb-6 sm:mb-8">
          {services.map((s) => (
            <span key={s} className="tag-pill text-[11px]">
              {s}
            </span>
          ))}
        </div>

        <a
          href={website}
          target="_blank"
          rel="noopener noreferrer"
          className="glass-btn inline-flex items-center gap-2 px-5 sm:px-6 py-2.5 text-xs font-medium transition-all group-hover:gap-3"
        >
          Visitar site <ArrowUpRight size={14} />
        </a>
      </div>
    </div>
  );
};

export default BrandCard;
